import _ from 'lodash'

class DescriptionController {
  constructor(growl, ModelFactory, Resource, $state, $uibModal, Util) {
    'ngInject'

    let vm = this;
    vm.form = {};
    vm.summernoteOptions = Util.getSummernoteOptions();
    vm.htmlDescription = "";
    vm.save = save
    vm.$onInit = init
    vm.formSubmitted = false
    vm.remove = remove

    function init() {
      vm.modelName = vm.model // preso dal parent
      vm.modelStructure = _.result(ModelFactory,
        'get' + _.upperFirst(vm.modelName) + 'Structure')

      console.log("Lang:", vm.language)
      /*Invoke e.g ModelFactory.getNatureStructure()*/
    }

    function save(itemStrings) {

      if (vm.form[vm.language].$invalid) {
        vm.formSubmitted = true
        angular.forEach(vm.form[vm.language].$error, function (value, key) {
          if (key === 'numeric-array') {
            growl.error('Il geojeson inserito non è valido');
          } else if (key === 'required') {
            growl.error('Compilare tutti i campi obbligatori');
          }
        })
        return
      }

      let itemToSave = {}
      itemToSave[vm.modelName] = _.get(vm.item, vm.modelName)

      // Se non c'è l'id, la risorsa è nuova da inserire
      if (_.isNil(itemToSave[vm.modelName].id)) {

        itemToSave[vm.modelName].active = true
        itemToSave[vm.modelName + 'StringsList'] = _.get(vm.item,
          vm.modelName + 'StringsList')
        itemToSave.geoPoints = []
        /* Example: Resource.post('flora', vm.item.flora) */
        Resource.post(vm.modelName, itemToSave).then(res => {
          console.log('Risorsa salvata!', res)
          vm.item = res.data;
          if (vm.modelName === 'itinerary') {
            let model = _.get(itemToSave, vm.model)
            let geojson = JSON.parse(model.geojson)
            saveGeoPoints(geojson[0]).then(e => {
              growl.success('Risorsa creata con successo!')
              $state.go('dashboard.detail.description', {
                id: res.data[vm.modelName].id,
                modelName: vm.modelName,
              })
            })
          } else {
            growl.success('Risorsa creata con successo!')
            $state.go('dashboard.detail.description', {
              id: res.data[vm.modelName].id,
              modelName: vm.modelName,
            })
          }
        }, err => {
          growl.error('Errore nella creazione della risorsa')
        })
      }
      else {
        /* Example: Resource.put('flora', vm.item.flora) */
        itemToSave.geoPoints = _.get(vm.item, 'geoPoints');
        Resource.put(vm.modelName, itemToSave).then(res => {
          console.log('Risorsa salvata!', res)

          Resource.putStrings(vm.modelName, itemStrings).then(res => {
            console.log('Stringhe modificate per', itemStrings, 'risposta:',
              res)
            growl.success('Modifica salvata con successo')

            if (vm.modelName === 'itinerary') {
              let model = _.get(itemToSave, vm.model)
              let geojson = JSON.parse(model.geojson)
              saveGeoPoints(geojson[0])
            }
          })
        })
      }
    }

    /**
     * Save geo points
     */
    function saveGeoPoints(latLngArray) {

      let itemToSave = {}
      itemToSave[vm.model] = _.get(vm.item, vm.model)
      itemToSave.geoPoints = []
      let geoPoint = {
        latitude: latLngArray[1],
        longitude: latLngArray[0],
      }
      itemToSave.geoPoints.push(geoPoint)
      return Resource.putGeoPoints(vm.model, itemToSave).then(res => {
      }, err => {
        growl.error('Errore nel salvataggio delle coordinate geografiche')
      })
    }

    function remove() {
      $uibModal.open({
        component: 'confirmDialog',
        windowClass: 'modal-mini modal-primary',
        resolve: {
          message: () => 'Confermi di voler cancellare questa risorsa?',
        },
      }).result.then(() => {
        Resource.remove(vm.modelName, _.get(vm.item, vm.modelName + '.id')).then(res => {
          growl.success('Risorsa cancellata con successo!')

          $state.go('dashboard.list', {
            modelEnum: vm.modelName.toUpperCase(),
          })
        })
      })
    }
  }
}

export default DescriptionController



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/description/description.controller.js